// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_q6_","cls2":"UserTaggingPingBodyStyles-cls2_U3m UserTaggingPingBodyStyles-cls1_q6_"};